// Relationship to the cardholder, from a member's relCode.
export const REL_CODE_LABELS = {
  0: "Not Specified",
  1: "Cardholder",
  2: "Spouse",
  3: "Child",
  4: "Other",
  5: "Student",
  6: "Disabled Dependent",
  7: "Adult Dependent",
  8: "Significant Other",
};

// A null/empty/unrecognized relCode reads as "Not Specified".
export const getRelCodeLabel = (relCode) => {
  const parsed = Number.parseInt(String(relCode ?? "").trim(), 10);
  return REL_CODE_LABELS[parsed] || REL_CODE_LABELS[0];
};
